<template lang="pug">
  .content-inner.settings-integrations
    aiq-tabs(v-if="integrationsAvailable" v-model="activeName" type="border-card")
      aiq-tab-pane(v-if="canView('/settings/integrations/authentication')"
                  label="Authentication" name="authentication")
        authentication-tab
      aiq-tab-pane(v-if="canView('/settings/integrations/salesforce')"
                  label="Salesforce" name="salesforce")
        salesforce-tab
      aiq-tab-pane(v-if="canView('/settings/integrations/docusign')"
                   label="DocuSign" name="docusign")
        docu-sign-tab
      aiq-tab-pane(v-if="canView('/settings/integrations/adobesign')"
                   label="AdobeSign" name="adobesign")
        adobe-sign-tab
      aiq-tab-pane(v-if="canView('/settings/integrations/ms-outlook')"
                   label="MsOutlook" name="ms-outlook")
        ms-outlook-tab
      aiq-tab-pane(v-if="canView('/settings/integrations/share-point')"
                   label="SharePoint" name="share-point")
        sharepoint-tab
      aiq-tab-pane(v-if="canView('/settings/integrations/external-ai-backend')"
                   label="External AI Backend" name="external-backend-ai")
        external-backend-ai
    .content-empty-container(v-else)
      span.content-empty-item
        | No integrations available.
</template>

<script>
import { AuthenticationTab, SalesforceTab, DocuSignTab, AdobeSignTab, MsOutlookTab, SharepointTab, ExternalBackendAi } from './Tabs';

// the order that is displayed in tab view
const INTEGRATIONS = ['authentication', 'salesforce', 'docusign', 'adobesign', 'ms-outlook'];

export default {
  name: 'integrations',
  data() {
    return {
      integrationsAvailable: false,
      activeName: INTEGRATIONS[0],
    };
  },
  components: {
    AuthenticationTab,
    SalesforceTab, DocuSignTab,
    AdobeSignTab,
    MsOutlookTab,
    SharepointTab,
    ExternalBackendAi,
  },
  created() {
    for (const integration of INTEGRATIONS) {
      if (this.canView(`/settings/integrations/${integration}`)) {
        this.integrationsAvailable = true;
        break;
      }
    }
  },
  mounted() {
    const path = this.$route.path;
    for (const name of INTEGRATIONS) {
      if (path.includes(name)) {
        this.activeName = name;
      }
    }
  },
};
</script>

<style lang="scss">
.settings-integrations.content-inner {
  .el-tab-pane .content-inner{
    padding: 0;
  }
  .el-tabs__content {
    overflow-y: auto;
    height: calc(100vh - 118px);
  }
}
</style>



